import { CallSourceBilling } from "./callsource_billing";

export class GroupBilling extends HTMLElement {
  constructor(data, is_admin) {
    super();
    this.is_admin = is_admin;
    this.data = data;
  }

  connectedCallback() {
    this.requestUpdate();
  }

  requestUpdate() {
    this.innerHTML = `
      <style>
        @media only screen and (min-width: 1200px) {
          .contact_address_container {
            padding-right: 4px !important;
          }
          .billing_address_container {
            padding-left: 4px !important;
          }
        }

        #tablist3 {
          margin: 0 0 20px 0 !important;
        }
      </style>
      <h3 style="float: left;width: 100%;">Billing</h3>
      <p>Configure the billing settings.</p>
      <div class="form-group">
        ${this.is_admin ? `
          <div>
            <label for="billing_type_id">Billing Type</label>
          </div>
          <div class="col-md-11 no-gutters">
            <select id="billing_type_id" class="form-control">
              <option value="1" ${this.data.billing_type_id == 1 ? 'selected' : ''}>Bill group separately</option>
              <option value="2" ${this.data.billing_type_id == 2 ? 'selected' : ''}>Bill to parent group</option>
              ${this.is_admin ? `<option value="0" ${this.data.billing_type_id == 0 ? 'selected' : ''}>Do not Bill</option>` : ``}
            </select>
          </div>
          <div class="col-md-1">
            <button id="group-billing-submit" class="btn btn-primary pull-right">Save</button>
          </div>
        ` : `
          <label for="billing_type_id">Billing Type: </label>
          <input type="hidden" value="${this.data.billing_type_id}" id="billing_type_id" class="form-control">
          <b>
          ${this.data.billing_type_id == 0 ? 'Do not Bill' : ''}
          ${this.data.billing_type_id == 1 ? 'Bill group separately' : ''}
          ${this.data.billing_type_id == 2 ? 'Bill to parent group' : ''}
          </b>
        `}
      </div>
    `;

    if(this.querySelector("#group-billing-submit")) {
      this.querySelector("#group-billing-submit").addEventListener("click", function(e){e.preventDefault(); this.save()}.bind(this))
    }

    if(this.data.is_callsource_owned && this.data.billing_type_id == 1) {
      let callsourceBilling = new CallSourceBilling(this.data);
      this.appendChild(callsourceBilling);
    }
  }

  async save() {
    let res = await fetch(`/admin/groups/${this.data.id}/billing`, {
        headers: {'X-CSRF-Token': $('meta[name="csrf-token"]').attr('content'),
                  'Content-type': 'application/json'},
        method: 'POST',
        body: JSON.stringify({billing_type_id: Number(this.querySelector("#billing_type_id").value)})
      })
    let data = await res.json();
    if(res.ok && data.success) {
      this.data = data.group;
      this.requestUpdate();
    }

    Common.notify("Successfully updates group.", 'success');
  }
}

customElements.define("group-billing", GroupBilling);